const config = {
    projectId: "dreico-development",
    communityName: "Development",
    productionUrl: "https://development.dreico.net",
    algoliaIndex: "development_user",
}

export default config